/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SecurityItemResponse as ModelsV3LoanManagementSecurityItemResponse } from '../../models/Models/v3/LoanManagement/security-item-response';

export interface V3LoanManagementSecurityItemsGet$Xml$Params {
  id?: string;
  vin?: string;

/**
 * Optional.
 */
  settlementDate?: string;
}

export function v3LoanManagementSecurityItemsGet$Xml(http: HttpClient, rootUrl: string, params?: V3LoanManagementSecurityItemsGet$Xml$Params, context?: HttpContext): Observable<StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>> {
  const rb = new RequestBuilder(rootUrl, v3LoanManagementSecurityItemsGet$Xml.PATH, 'get');
  if (params) {
    rb.query('id', params.id, {});
    rb.query('vin', params.vin, {});
    rb.query('settlementDate', params.settlementDate, {});
  }

  return http.request(
    rb.build({ responseType: 'text', accept: 'text/xml', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Array<ModelsV3LoanManagementSecurityItemResponse>>;
    })
  );
}

v3LoanManagementSecurityItemsGet$Xml.PATH = '/v3/loan-management/security-items';
